import React, { useEffect, useRef } from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import variablePie from "highcharts/modules/variable-pie.js";

variablePie(Highcharts);

const options = {
  title: {
    text: "",
    margin: 50,
    style: { fontSize: "2rem", fontWeight: "bold" },
  },
  chart: {
    type: "variablepie",
    style: {
      fontFamily: `Roboto, -apple-system, BlinkMacSystemFont, "Segoe UI",
    "Helvetica Neue", Arial, "Noto Sans", sans-serif,
    "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"`,
    },
  },
  exporting: {
    enabled: false,
  },
  credits: {
    enabled: false,
  },
  colors: ["#2F5EC4", "#45a5f5"],
  yAxis: {
    lineWidth: 1,
    title: {
      enabled: false,
    },
  },
  xAxis: {
    type: "datetime",
    labels: {
      style: { fontWeight: "bold" },
    },
    lineWidth: 1,
  },
  tooltip: {
    shared: true,
  },
  series: [
    {
      minPointSize: 10,
      innerSize: "20%",
      zMin: 0,
      name: "countries",
      data: [
        {
          name: "Spain",
          y: 505370,
          z: 92.9,
        },
        {
          name: "France",
          y: 551500,
          z: 118.7,
        },
        {
          name: "Poland",
          y: 312685,
          z: 124.6,
        },
        {
          name: "Czech Republic",
          y: 78867,
          z: 137.5,
        },
        {
          name: "Italy",
          y: 301340,
          z: 201.8,
        },
        {
          name: "Switzerland",
          y: 41277,
          z: 214.5,
        },
        {
          name: "Germany",
          y: 357022,
          z: 235.6,
        },
      ],
    },
  ],
};

function Result() {
  const chartRef = useRef(null);
  const wrapperRef = useRef(null);

  const handleResize = () => {
    if (wrapperRef && wrapperRef.current) {
      if (chartRef && chartRef.current) {
        chartRef.current.chart.update(
          {
            chart: {
              width: wrapperRef.current.clientWidth - 16,
            },
          },
          true
        );
        // console.log("resized to: ", wrapperRef.current.clientWidth, dataset);
      }
    }
  };

  useEffect(() => {
    window.addEventListener("resize", handleResize);

    setTimeout(() => {
      window.dispatchEvent(new Event("resize"));
    }, 1000);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
    // eslint-disable-next-line
  }, []);

  const afterChartCreated = (chart) => {
    handleResize();
    // console.log(chart);
  };

  return (
    <div className="flex flex-col h-full flex-grow">
      <div className="flex justify-between items-center">
        <div className="flex-shrink-0 flex items-center">
          <span className="font-light text-lg text-gray-700 tracking-wide">
            Details
          </span>
        </div>
      </div>

      <div
        className={`flex flex-col mt-1 bg-white border border-gray-200 rounded p-5 pt-7`}
        ref={wrapperRef}
      >
        <div className="flex justify-between items-center mb-12 px-2">
          <h5 className="text-gray-750 mb-0">Traffic</h5>
        </div>

        <div className="flex justify-center">
          <HighchartsReact
            ref={chartRef}
            highcharts={Highcharts}
            options={options}
            callback={afterChartCreated}
          />
        </div>
      </div>
    </div>
  );
}

export default Result;
